import { combineReducers } from 'redux';
import { reducer as albumItem } from './albumItem';
import { reducer as albumCustomizeNav } from './albumCustomizeNav';
import { reducer as draftsAndOrders } from './draftsAndOrders';
import { reducer as gallery } from './gallery';
import { reducer as modal } from './modal';
import { reducer as project } from './project';
import { reducer as contentLayout } from './contentLayout';
import { reducer as coverCustomization } from './coverCustomization';
import { reducer as uiSettings } from './uiSettings';

const photobooks = combineReducers({
  albumItem,
  albumCustomizeNav,
  draftsAndOrders,
  gallery,
  modal,
  project,
  contentLayout,
  coverCustomization,
  uiSettings,
});

export default photobooks;



// WEBPACK FOOTER //
// ./src/photobooks/reducers/index.js